export default __webpack_public_path__ + "static/media/object--sign--advertisement.1d13d128.png";